import { c as _c } from "react/compiler-runtime";
import { DateRangePicker, Status } from '@systemeio/components';
import { useFunnelSales } from 'modules/funnels/funnel/components/sales-tab/hooks/use-funnel-sales';
import { FunnelSalesFilterInterface, FunnelSalesInterface } from 'modules/funnels/funnel/components/sales-tab/types/funnel-sales-interface';
import { getSalePriceDescription } from 'modules/funnels/funnel/components/sales-tab/utils/get-sale-price-description';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { useState } from 'react';
import ListingLayout from 'shared/components/listing-layout';
import { RelativeTime } from 'shared/components/relative-time';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import ContactInfoTooltip from 'shared/components/tooltip/contact-info-tooltip';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { getDatePickerMinDate } from 'shared/utils/get-date-picker-min-date';
import { getDateRangeWithDaysDifference, getToday } from 'shared/utils/get-dates';
interface SalesTabProps {
  funnelId: FunnelId;
}
const defaultFilters: FunnelSalesFilterInterface = {
  date: [null, null]
};
function SalesTab(t0) {
  const $ = _c(77);
  const {
    funnelId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    isWsAssistant,
    intlLocale
  } = useUser();
  const {
    limit,
    setLimit,
    pagination,
    setPagination
  } = usePagination(true);
  const [filter, setFilter] = useState(defaultFilters);
  let t1;
  if ($[0] !== filter || $[1] !== funnelId || $[2] !== limit || $[3] !== pagination) {
    t1 = {
      limit,
      pagination,
      filter,
      funnelId
    };
    $[0] = filter;
    $[1] = funnelId;
    $[2] = limit;
    $[3] = pagination;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    sales
  } = useFunnelSales(t1);
  let t2;
  if ($[5] !== t) {
    t2 = t("dashboard.funnel.sales_date");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = {
      key: "createdAt",
      header: t2,
      widthPercent: 15,
      onRender: _temp
    };
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("dashboard.funnel.sales_step");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = {
      key: "offer",
      header: t4,
      widthPercent: 25,
      onRender: _temp2
    };
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("dashboard.funnel.sales_price");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== user) {
    t7 = sale_1 => <>{getSalePriceDescription(sale_1, user)}</>;
    $[15] = user;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = {
      key: "productOrderItem",
      header: t6,
      widthPercent: 25,
      onRender: t7
    };
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("dashboard.funnel.sales_customer");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== isWsAssistant || $[23] !== t) {
    t10 = sale_2 => <>{!isWsAssistant ? <ContactInfoTooltip fields={sale_2.order.customer.fieldValues} referredByEmail={sale_2.order?.customer?.referredBy?.email} type={sale_2.order.customer.type} contactId={sale_2.order.customer.contact.id}><span className="w-full truncate">{sale_2.order.customer.email}</span></ContactInfoTooltip> : <span>{t("global.hidden")}</span>}</>;
    $[22] = isWsAssistant;
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = {
      key: "order",
      header: t9,
      widthPercent: 30,
      onRender: t10
    };
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t) {
    t12 = t("dashboard.funnel.sales_status");
    $[28] = t;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t) {
    t13 = sale_3 => <Status color={sale_3.cancelledAt ? "error" : "active"} size="md">{sale_3.cancelledAt ? t("dashboard.funnel.sales_status_revoked-2") : t("dashboard.funnel.sales_status_received-2")}</Status>;
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t12 || $[33] !== t13) {
    t14 = {
      key: "cancelledAt",
      header: t12,
      widthPercent: 30,
      onRender: t13
    };
    $[32] = t12;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t11 || $[36] !== t14 || $[37] !== t3 || $[38] !== t5 || $[39] !== t8) {
    t15 = [t3, t5, t8, t11, t14];
    $[35] = t11;
    $[36] = t14;
    $[37] = t3;
    $[38] = t5;
    $[39] = t8;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  const columns = t15;
  let t16;
  if ($[41] !== t) {
    t16 = t("dashboard.funnel.statistics.sales");
    $[41] = t;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== filter) {
    t17 = {
      filter,
      setFilter,
      defaultFilters
    };
    $[43] = filter;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== intlLocale || $[46] !== user?.createdAt || $[47] !== user?.timezone) {
    t18 = [{
      field: "date",
      onRender: (value, onChange) => <DateRangePicker key="funnel-sales-date-filter" maxDate={getToday(user?.timezone)} getDefaultDate={() => getDateRangeWithDaysDifference(57, user?.timezone)} date={value} onChange={date => onChange(date)} timezone={user?.timezone} minDate={getDatePickerMinDate(user?.createdAt, user?.timezone)} intlLocale={intlLocale} />
    }];
    $[45] = intlLocale;
    $[46] = user?.createdAt;
    $[47] = user?.timezone;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== setPagination || $[50] !== t17 || $[51] !== t18) {
    t19 = {
      setPagination,
      filterer: t17,
      filterable: t18
    };
    $[49] = setPagination;
    $[50] = t17;
    $[51] = t18;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== limit || $[54] !== setLimit) {
    t20 = {
      limit,
      setLimit
    };
    $[53] = limit;
    $[54] = setLimit;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== pagination || $[57] !== setPagination) {
    t21 = {
      pagination,
      setPagination
    };
    $[56] = pagination;
    $[57] = setPagination;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  let t22;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {};
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  let t23;
  if ($[60] !== t) {
    t23 = t("dashboard.funnel.sales_tab.empty.title");
    $[60] = t;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== t) {
    t24 = t("dashboard.funnel.sales_tab.empty.description");
    $[62] = t;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  let t25;
  if ($[64] !== t23 || $[65] !== t24) {
    t25 = {
      title: t23,
      description: t24
    };
    $[64] = t23;
    $[65] = t24;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  let t26;
  if ($[67] !== columns || $[68] !== sales || $[69] !== t20 || $[70] !== t21 || $[71] !== t25) {
    t26 = <Table data={sales} columns={columns} limiter={t20} paginator={t21} actions={t22} emptyStateProps={t25} />;
    $[67] = columns;
    $[68] = sales;
    $[69] = t20;
    $[70] = t21;
    $[71] = t25;
    $[72] = t26;
  } else {
    t26 = $[72];
  }
  let t27;
  if ($[73] !== t16 || $[74] !== t19 || $[75] !== t26) {
    t27 = <div><ListingLayout counter={false} title={t16} filterData={t19}>{t26}</ListingLayout></div>;
    $[73] = t16;
    $[74] = t19;
    $[75] = t26;
    $[76] = t27;
  } else {
    t27 = $[76];
  }
  return t27;
}
function _temp2(sale_0) {
  return <div className="truncate">{sale_0.offer.funnelStep.name}</div>;
}
function _temp(sale) {
  return <span><RelativeTime time={sale.createdAt} /></span>;
}
export default SalesTab;